import { defineMessages } from 'react-intl';

export const codeSnippetActionsMenuMessages = defineMessages({
  triggerLabel: {
    defaultMessage: 'Code snippet actions',
    id: 'R5VDokjiAIL+eFdM',
    description: 'Aria label for the code snippet actions menu trigger button.',
  },
  copy: {
    defaultMessage: 'Copy',
    id: 'Yi8j4dchtpkwn/OB',
    description: 'Shown for elements that trigger a copy to clipboard',
  },
  copied: {
    defaultMessage: 'Copied',
    id: 'THNwSvfvDSXAUapi',
    description: 'Shown after copying to clipboard',
  },
  download: {
    defaultMessage: 'Download',
    id: 'nNhGwqwcL0EfGw1A',
    description: 'Shown for elements that trigger a file download',
  },
});
